import { useEffect, useState } from "react";
import {
  ActionButton,
  Button,
  Container,
  Icon,
  InputField,
  InputPhoneDropdown,
  Notifications,
  Text,
} from "@jds/core";
import {
  emptyObj,
  validateEmail,
  validatePhoneNumber,
  validateTextInput,
} from "../../../util/validation";
import useInput from "../../../hooks/use-input";
import imageUploaded, { baseToImg, fileToBase } from "../../../util/helper";
import useApiHttp from "../../../hooks/use-http";
import PageLoader from "../Loader/PageLoader";
import JdsModal from "../JdsModal";
import AvatarView from "../Views/avatarView/AvatarView";
import AvatarUploadCamera from "./avatarUpload/AvatarUploadCamera";
import { useSelector } from "react-redux";
import decryptUrl from "../../../util/img-decryption";
import { Box } from "@mui/material";
import AdditionalDetailsForm from "./AdditionalDetailsForm";

export default function ProfileDetailForm(props) {
  const [userSelectProfile, setUserSelectProfile] = useState("");
  const [profileImgModalClose, setrofileImgModalClose] = useState(true);
  const [profileImgFile, setProfileImgFile] = useState();
  const [profileHeader, setProfileHeader] = useState("Upload profile picture");
  const [socialLinksModalClose, setSocialLinksModalClose] = useState(true);
  const [socialMediaLinks, setSocialMediaLinks] = useState({});
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails
  );
  const { sendRequest: updateProfile, isLoading: isProfileUpdating } =
    useApiHttp();

  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();
  const [selectedCountry, setSelectedCountry] = useState();
  const {
    value: profileImage,
    isValid: isValidProfileImage,
    hasError: profileImageError,
    valueChangeHandler: profileImageChangeHandler,
    inputBlurHandler: profileImageBlurHandler,
    reset: resetProfileImage,
  } = useInput(validateTextInput, {
    type: "text",
    value: profileDetailsRedux?.profilePictureThumbnailUrl,
  });

  const {
    value: firstName,
    isValid: isValidFirstName,
    hasError: firstNameError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
  } = useInput(validateTextInput, {
    type: "text",
    value: profileDetailsRedux?.firstName,
  });
  const {
    value: lastName,
    isValid: isValidlastName,
    hasError: lastNameError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
  } = useInput(validateTextInput, {
    type: "text",
    value: profileDetailsRedux?.lastName,
  });
  const {
    value: phoneNumber,
    isValid: isValidPhoneNumber,
    hasError: phoneNumberError,
    valueChangeHandler: phoneNumberChangeHandler,
    inputBlurHandler: phoneNumberBlurHandler,
    reset: resetPhoneNumber,
  } = useInput(validatePhoneNumber, {
    type: "text",
    value: profileDetailsRedux?.phoneNumber,
  });
  const {
    value: emailAddress,
    isValid: isValidEmailAddress,
    hasError: emailAddressError,
    valueChangeHandler: emailAddressChangeHandler,
    inputBlurHandler: emailAddressBlurHandler,
    reset: resetEmailAddress,
  } = useInput(validateEmail, {
    type: "text",
    value: profileDetailsRedux?.email,
  });

  // const isValidForm =
  //   !isValidFirstName ||
  //   !isValidlastName ||
  //   !isValidEmailAddress ||
  //   !isValidPhoneNumber ||
  //   !isValidProfileImage;

  const isValidForm =
    !isValidFirstName || !isValidlastName || !isValidEmailAddress;

  const handleSubmit = () => {
    const countryCode = countryCodeItems.filter((items, index) => {
      if (index == selectedCountry) {
        return items;
      }
    })[0]?.value;
    if (profileImgFile) {
      const formData = new FormData();
      formData.append("uploadFile", profileImgFile);
      getFaceCount(
        {
          base: "MEDIA",
          url: `face/get-face-count`,
          method: "POST",
          body: formData,
          formData: true,
        },
        null,
        (data) => {
          const userProfile = new FormData();
          userProfile.append("email", emailAddress || null);
          userProfile.append("firstName", firstName);
          userProfile.append("lastName", lastName);
          userProfile.append("profilePicture", profileImgFile);
          let socialObj = {
            facebook: null,
            instagram: null,
            youtube: null,
            email: null,
            website: null,
            mobile: null,
          };
          userProfile.append(
            "metadata",
            JSON.stringify({ ...socialObj, ...socialMediaLinks })
          );
          updateProfile(
            {
              base: "AUTH",
              url: `profile`,
              method: "PUT",
              body: userProfile,
              formData: true,
            },
            null,
            (data) => {
              Notifications.toast.success({
                id: "update-profile",
                title: data?.message,
              });
              props.closeModal();
              props?.updateProfile();
            },
            (err, data) => {
              Notifications.toast.error({
                id: "update-profile",
                title: data?.message,
              });
            }
          );
        },
        (err, data) => {
          Notifications.toast.error({
            id: "get-face-count-error",
            title: data?.message,
          });
        }
      );
    } else {
      const userProfile = new FormData();
      userProfile.append("email", emailAddress || null);
      userProfile.append("firstName", firstName);
      userProfile.append("lastName", lastName);
      let socialObj = {
        facebook: null,
        instagram: null,
        youtube: null,
        email: null,
        website: null,
        mobile: null,
      };
      userProfile.append(
        "metadata",
        JSON.stringify({ ...socialObj, ...socialMediaLinks })
      );
      updateProfile(
        {
          base: "AUTH",
          url: `profile`,
          method: "PUT",
          body: userProfile,
          formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "update-profile",
            title: data?.message,
          });
          props.closeModal();
          props?.updateProfile();
        },
        (err, data) => {
          Notifications.toast.error({
            id: "update-profile",
            title: data?.message,
          });
        }
      );
    }
    // resetFirstName();
    // resetLastName();
    // resetPhoneNumber();
    // resetEmailAddress();
    // resetProfileImage();
  };

  const countryCodeItems = [
    {
      label: "+88",
      prefix: <Icon ic={"IcAdd"} />,
      value: "+88",
    },
    {
      label: "+78",
      prefix: <Icon ic={"IcAdd"} />,
      value: "+78",
    },
    {
      label: "+91",
      prefix: <Icon ic={"IcAdd"} />,
      value: "+91",
    },
  ];
  let selectedCountryLabel = countryCodeItems[selectedCountry || 0]?.label;
  const [countryCodeUpdate, setCountryCodeUpdate] = useState(false);
  useEffect(() => {
    countryCodeItems.filter((item, index) => {
      if (item.value === profileDetailsRedux?.countryCode) {
        setSelectedCountry(index);
        setCountryCodeUpdate(true);
      }
    });
    let socialObj = profileDetailsRedux?.metadata || {};
    let socialObjValid = Object.fromEntries(
      Object.entries(socialObj).filter(
        ([key, value]) => value !== null && value !== ""
      )
    );
    setSocialMediaLinks(socialObjValid);
  }, []);

  return (
    <>
      <div action="" className="column-form">
        <div style={{ textAlign: "center" }}>
          <AvatarView
            image={
              userSelectProfile
                ? baseToImg(userSelectProfile)
                : profileDetailsRedux?.profilePictureThumbnailUrl
                ? decryptUrl(profileDetailsRedux?.profilePictureThumbnailUrl)
                : ""
            }
            onClick={() => {
              setrofileImgModalClose(false);
            }}
          />
        </div>

        <JdsModal
          header={profileHeader}
          size="m"
          close={profileImgModalClose}
          onClose={() => {
            setrofileImgModalClose(true);
          }}
        >
          {!profileImgModalClose && (
            <AvatarUploadCamera
              image={
                userSelectProfile
                  ? baseToImg(userSelectProfile)
                  : profileDetailsRedux?.profilePictureThumbnailUrl
                  ? decryptUrl(profileDetailsRedux?.profilePictureThumbnailUrl)
                  : ""
              }
              accept=".png ,.jpg ,.jpeg"
              fileValue={(file) => {
                setProfileImgFile(file);
                fileToBase(file)
                  .then((base64Value) => {
                    setUserSelectProfile(base64Value);
                    profileImageChangeHandler({
                      target: { value: base64Value },
                    });
                  })
                  .catch((error) => {});
              }}
              setProfileHeader={(e) => setProfileHeader(e)}
            />
          )}
        </JdsModal>

        <InputField
          label="First Name*"
          value={firstName}
          name="firstName"
          onChange={firstNameChangeHandler}
          onBlur={firstNameBlurHandler}
          state={firstNameError ? "error" : ""}
          stateText="Please enter a valid name!"
        />
        <InputField
          label="Last Name*"
          value={lastName}
          name="lastName"
          state={lastNameError ? "error" : ""}
          stateText="Please enter a valid name!"
          onChange={lastNameChangeHandler}
          onBlur={lastNameBlurHandler}
        />
        {/* <InputField
        label="Phone Number"
        value={phoneNumber}
        name="phoneNumber"
        onChange={phoneNumberChangeHandler}
        onBlur={phoneNumberBlurHandler}
        state={phoneNumberError ? "error" : ""}
        stateText="phone number is invalid"
      /> */}

        <InputField
          label="Phone Number"
          value={phoneNumber}
          name="phoneNumber"
          onChange={phoneNumberChangeHandler}
          onBlur={phoneNumberBlurHandler}
          state={phoneNumberError ? "error" : ""}
          stateText="Please enter a valid number!"
          type="number"
          disabled
          prefix={
            countryCodeUpdate ? (
              <InputPhoneDropdown
                selectedIndex={selectedCountry}
                items={countryCodeItems}
                countryCode={selectedCountryLabel}
                onSelect={(idx) => {
                  setSelectedCountry(idx);
                }}
              />
            ) : (
              ""
            )
          }
        />

        <InputField
          label="Email*"
          value={emailAddress}
          name="emailAddress"
          onChange={emailAddressChangeHandler}
          onBlur={emailAddressBlurHandler}
          state={emailAddressError ? "error" : ""}
          stateText="Please enter a valid email id!"
        />
        {/* <Box
          mt={1}
          sx={{ cursor: "pointer" }}
          onClick={() => setSocialLinksModalClose(false)}
        >
          <Text
            text="Add more details"
            color="primary_60"
            appearance="body-s-bold"
          />
        </Box> */}
        <Container
          fullWidth
          horizontalAlign="center"
          style={{ marginTop: "24px", width: "200px", margin: "auto" }}
        >
          <Button
            disabled={isValidForm}
            type="submit"
            fullWidth
            label="Save"
            size="large"
            onClick={handleSubmit}
            loading={isProfileUpdating}
          />
        </Container>
      </div>
      <JdsModal
        header="Additonal Details"
        close={socialLinksModalClose}
        onClose={() => {
          setSocialLinksModalClose(true);
        }}
        size="m"
      >
        <Box sx={{ p: "12px 24px" }}>
          <AdditionalDetailsForm
            onCancel={() => setSocialLinksModalClose(true)}
            setSocialMediaLinks={setSocialMediaLinks}
            socialMediaLinks={socialMediaLinks}
          />
        </Box>
      </JdsModal>
      {isProfileUpdating ||
        (isGetFaceCounting && (
          <PageLoader open={isProfileUpdating || isGetFaceCounting} />
        ))}
    </>
  );
}
